import React, { useState } from 'react';

import { FormComponent, UiComponent } from 'components';
import useModal from 'hooks/useModal';

interface Props {
  initialLabel?: string;
  initialUrl?: string;
  handleSelect: (data: { label: string; link: string }) => void;
}

function LinkSelector({
  initialLabel = '',
  initialUrl = '',
  handleSelect,
}: Props) {
  const { handleClose } = useModal();
  const [label, setLabel] = useState(initialLabel);
  const [url, setUrl] = useState(initialUrl);

  const handleConfirm = () => {
    handleSelect({ label, link: url });
    handleClose();
  };

  return (
    <div css={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <label css={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <span css={{ fontSize: '12px', fontWeight: 600 }}>버튼 텍스트</span>
        <FormComponent.Input
          type="text"
          placeholder="예) 자주 묻는 질문 바로가기"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
          autoFocus
        />
      </label>
      <label css={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
        <span css={{ fontSize: '12px', fontWeight: 600 }}>이동 링크</span>
        <FormComponent.Input
          type="text"
          placeholder="https://example.com"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
      </label>
      <div css={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
        <UiComponent.Button
          variant="border"
          color="primary"
          onClick={handleClose}
        >
          취소
        </UiComponent.Button>
        <UiComponent.Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
        >
          확인
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default LinkSelector;
